/**
 * 管理员详情抽屉：所有管理员都可以查看
 */
import { useEffect } from 'react'
import { App, Descriptions, Drawer, Space, Spin, Tag, Typography } from 'antd'
import { apiErrorMessage, useAdminDetail } from './hooks'
import { formatAdminTime, roleColor, roleName } from './constants'

export function AdminDetailDrawer({ adminId, onClose }: Readonly<{ adminId: number | null; onClose: () => void }>) {
  const { message } = App.useApp()
  const { data: detail, isLoading, error } = useAdminDetail(adminId)

  useEffect(() => {
    if (error) message.error(apiErrorMessage(error, '加载详情失败'))
  }, [error, message])

  return (
    <Drawer open={adminId !== null} title="管理员详情" size={500} placement="right" onClose={onClose}>
      {isLoading && <Spin />}
      {detail && (
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="ID">{detail.id}</Descriptions.Item>
          <Descriptions.Item label="用户名">{detail.username}</Descriptions.Item>
          <Descriptions.Item label="邮箱">{detail.email}</Descriptions.Item>
          <Descriptions.Item label="显示名称">{detail.display_name || '-'}</Descriptions.Item>
          <Descriptions.Item label="角色">
            <Tag color={roleColor(detail.role)}>{roleName(detail.role)}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={detail.is_active ? 'success' : 'error'}>{detail.is_active ? '活跃' : '禁用'}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="额外权限">
            {detail.permissions?.length ? (
              <Space size={[4, 4]} wrap>
                {detail.permissions.map((permission) => (
                  <Tag key={permission} color="blue">
                    {permission}
                  </Tag>
                ))}
              </Space>
            ) : (
              <Typography.Text type="secondary">无额外权限</Typography.Text>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="创建时间">{formatAdminTime(detail.created_at)}</Descriptions.Item>
          <Descriptions.Item label="最后登录">
            {detail.last_login_at ? formatAdminTime(detail.last_login_at) : '从未登录'}
          </Descriptions.Item>
          <Descriptions.Item label="登录尝试次数">{detail.login_attempts || 0}</Descriptions.Item>
        </Descriptions>
      )}
    </Drawer>
  )
}
